export default __webpack_public_path__ + "static/media/wantaki-logo-large.b9fb307f.png";